export default {
  loading: "Loading...",
  open: "Open",
  close: "Close",
  stake: "Stake",
  crdr: "W/L",
  item: "Item",
  valid: "Valid",
  home_preferences: "Home Preferences",
  quick_links: "Quick Links",
  language: "Language",
  home_page: "Home",
  favorites: "နှစ်သက်ရာ",
  note: "သတိ",
  my_bets: "My Bets",
  my_account: "အကောင့်",
  contact_us: "ဆက်သွယ်ရန်",
  report: "တင်ပြသည်",
  help_support: "အကူအညီနှင့်ထောက်ပံ့မှု",
  currency: "ငွေကြေးပုံစံ",
  others: "အခြား",
  welcome: "ကြိုဆိုပါသည်",
  account_id: "အကောင့်အိုင်ဒီ",
  password: "စကားဝှက်",
  account: "အကောင့်",
  all_sports: "အားကစား အားလုံး",
  my_sports: "အားကစားပွဲများ",
  action: "ပြုလုပ်သည်",
  accept_better_odds: "အလိုအလျောက် ပိုကောင်းသည့်ပေါက်ကြေးလက်ခံခြင်း",
  accept_any_odds: "အလိုအလျောက် ပေါက်ကြေးလက်ခံခြင်း",
  auto_refresh_odds: "ပေါက်ကြေးအလိုအလျောက် ပြောင်းလဲခြင်း",
  auto_refresh: "အလိုအလျောက်ပြောင်းလဲခြင်း",
  auto_refreshing: "အလိုအလျောက်ပြောင်းလဲနေသည်...",
  all_markets: "ပေါက်ကြေးအားလုံး",
  available_balance: "Available Balance",
  athletics: "Athletics",
  american_football: "American Football",
  aussie_rules_football: "Aussie Rules Football",
  gmail: "Gmail",
  contact_number: "Contact Number",

  away: "အ‌ဝေး",

  all: "အားလုံး",
  accepted: "လက်ခံသည်",
  add: "Add",
  add_homescreen: "Add to Home screen",
  abandoned: "Abandoned",

  bet_slip: "လောင်းကြေးစလစ်",
  bet_credit: "လောင်းကြေး",
  bet_list: "‌လောင်းထားသည့် ဇယား",
  betting: "လောင်းနေသည်",
  balance: "လက်ကျန်",

  betting_statement: "လောင်းကြေးစာရင်း",
  betting_rules: "Betting Rules",
  bet_types: "လောင်းကြေးပုံစံ",
  bs: "အကြီး / အသေး",
  bet_summary: "လောင်းကြေးအနှစ်ချုပ်",
  bets: "လောင်းကြေးများ",
  basketball: "ဘတ္စကက္ေဘာ",
  baseball: "ေဘ့စေဘာ",
  badminton: "ကြက်တောင်ရိုက်ခြင်	",
  bandy: "Bandy",
  boxing: "	လက္ေဝွ႕",
  beach_soccer: "သဲေသာင္ျပင္ ေဘာလုံး",

  casino: "ကာစီနို",
  cash_balance: "လက်ငင်းငွေလက်ကျန်",
  change_account_password: "အကောင့်စကားဝှက်အား ပြောင်းသည်",
  current_password: "လက်ရှိစကားဝှက်",
  confirm_new_password: "စကားဝှက်အသစ်အား အတည်ပြုသည်",
  customize_sports_order: "အားကစားပွဲအစဥ်လိုက်များအား ကိုယ်ပိုင်ဖန်တီးမှု",
  choice: "ရွေးချယ်သည်",
  credit: "အကြွေး",
  commission: "ကော်မရှင်",
  customize: "ကိုယ်ပိုင်ဖန်တီးမှု",
  cancel: "ပယ်ဖျက်သည်",
  confirmation: "အတည်ပြုသည်",
  continue_bet: "Continue Bet",
  customer_service: "Customer Service Hotline",
  cricket: "ကရစ်ကက်	",
  cycling: "စက္ဘီး	",
  copa_america: "Copa America",
  combinations: "Combinations",
  create_room: "Create Private Room",

  darts: "ျမႇား/ဓား ေပါက္",
  debit: "ဝင်ငွေ",
  display_language: "ဘာသာစကားဖော်ပြခြင်း",
  default_event_sorting: "ပုံမှန်ထည့်သွင်းထားသော ပွဲစဥ်များ",
  default_stake: "ပုံမှန်ထည့်သွင်းထားသော လောင်းကြေး",
  date: "ရက်စွဲ",
  draw: "သရေ",
  draw_cancel: "Draw",
  dec: "ဥရောပပေါက်ကြေး",
  double_line: "ပေါက်ကြေး ၂ မျိုး",
  ddisable: "မပြုလုပ်နိုင်",
  dec_odds: "ဥရောပပေါက်ကြေး",
  id_odds: "အင်ဒိုပေါက်ကြေး",
  double_chance: "နှစ်ထပ်အခွင့်အရေး",
  details: "Details",

  enable: "အသုံးပြုသည်",
  event_sorting: "event_sorting",
  e_sports: "E-Sports",
  esports2: "E-Sports 2",
  edit: "ပြုပြင်",
  early: "အစောပွဲများ",
  event: "ပွဲစဥ်",
  even: "စုံ",
  email: "Email",
  esports: "E-Sports",
  euro: "EURO 2020",
  entry_fee: "Entry Fee",
  exclusive: "Exclusive",
  event_worldcup: "Worldcup 2026",
  event_euro: "EURO 2024",
  event_copa: "COPA 2024",
  event_olympic: "Olympic 2024",
  event_club_worldcup: "CLUB WORLD CUP",
  event_women_euro: "WOMEN's EURO",
  event_nation_league: "NATION LEAGUE",
  event_fifa_club: "FIFA CLUB",

  es_101: "Map 1",
  es_102: "Map 2",
  es_103: "Map 3",
  es_104: "Map 4",
  es_105: "Map 5",
  es_106: "Map 6",
  es_107: "Map 7",
  es_108: "Map 8",
  es_109: "Map 9",
  es_110: "Map 10",

  fd_101: "1ST Prize",
  fd_102: "2ND Prize",
  fd_103: "3RD Prize",

  first_goal: "ပထမဂိုး",
  first_half: "ပထမပိုင်း ရလဒ်",
  final: "နောက်ဆုံး ရလဒ်",
  full_time: "ပွဲချိန်ပြည့်",
  from: "From",
  field_hockey: "Field Hockey",
  futsal: "Futsal",
  fd: "4D Special",
  fishing: "Fishing",
  fold: "Fold",

  gaelic_football: "Gaelic Football",
  golf: "ဂေါက်သီး",
  games: "ကစားပွဲများ",
  given_credit: "ပေးထားသော အကြွေး",
  group: "အုပ်စု",
  goal: "ဂိုး",
  general: "General",
  general_betting_rules: "General Betting Rules",
  general_rules_market: "General Rules: Market (Bet Type)",

  half_time: "ပထမပိုင်း",
  hide_header: "ခေါင်းစဥ်များအား ဖျောက်ထားသည်",
  hk: "ဟောင်ကောင်",
  hk_odds: "ဟောင်ကောင် ပေါက်ကြေး",
  hdp: "HDP",
  home: "အိမ်ကွင်း",
  hotline: "Hotline",
  handball: "လက္ပစ္ေဘာလုံး",
  hurling: "Hurling",
  hour: "Hour",
  highlight: "Highlights",

  id: "အင်ဒို",
  ice_hockey: "ရေခဲပြင်ဟော်ကီ	",

  joined: "Joined Only",
  join_now: "Join Now",
  jackpot: "Jackpot",

  keno: "Keno",
  kickoff: "ပွဲစသည်",
  kabbadi: "Kabbadi",
  kof: "King of Figthers",
  ko: "K.O By",

  lose: "ရှုံးသည်",
  lose_half: "တဝက်ရှုံး",
  lottery: "Lottery",
  login: "ဝင်ရောက်သည်",
  logout: "ထွက်သည်",
  last_login: "နောက်ဆုံး ဝင်ရောက်ခြင်း",
  last_transaction: "နောက်ဆုံး စာရင်း",
  live_streaming: "တိုက်ရိုက် ထုတ်လွှင့်မှု",
  live_match: "တိုက်ရိုက် ကစားပွဲ",
  live_chat: "Live Chat",
  live: "တိုက်ရိုက်",
  virtual: "ဗာကျူရယ်",
  live_tv: "တိုက်ရိုက် TV",
  livecasino: "တိုက်ရိုက် ကာစီနို",
  loss: "အရှုံး",
  lost: "ရှုံးသည်",
  last_bet: "နောက်ဆုံး လောင်းကြေး",
  last_goal: "နောက်ဆုံးဂိုး",
  leave_room: "Leave Room",
  last_betting_time: "Last Betting Time",
  lose_all: "Lose All",

  mobile: "ဖုန်း",
  message: "အ‌ကြောင်းကြားစာ",
  my_bet: "မိမိကစားထားသော ပွဲများ",
  my_favorites: "မိမိ အနှစ်သက်ဆုံး",
  market_type: "ပေါက်ကြေးအမျိုးအစား",
  match: "ပွဲစဥ်",
  message_history: "အကြောင်းကြားစာ",
  my: "ကျွန်ုပ်",
  market: "ပေါက်ကြေး",
  main_markets: "အဓိကပေါက်ကြေး",
  my_odds: "မလေး ပေါက်ကြေး",
  mmo_parlay: "Myanmar Parlay",
  mmo_odds: "Myanmar Odds",
  min: "အနည်းဆုံး",
  max: "အများဆုံး",
  max_payout: "အများဆုံး လျော်ကြေး",
  main: "အဓိက",
  corners: "‌ဒေါင့်ကန်ဘော",
  specials: "အထူး",
  mix_parlay: "မောင်း",
  mma: "ေရာေႏွာ ကိုယ္ခံပညာ ၿပိဳင္ပြဲမ်ား",
  motorsports: "မော်တာအားကစား	",
  muay_thai: "Muay Thai",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  matches: "Matches",
  mini_arcade: "Mini Arcade",
  match_started: "-",

  no_goal: "ဂိုးမရှိပါ",
  normal_announcements: "ပုံမှန် သတိ‌ပေးစာ",
  nickname: "Nickname",
  new_password: "စကားဝှက်အသစ်",
  new: "အသစ်",
  "no/": "No.",
  normal_sorting: "မူရင်းအစဥ်အလိုက်",
  netball: "Netball",
  newsinfo: "News & Info",
  next: "Next",

  olympic: "Olympic",
  other_markets: "အခြားပေါက်ကြေး",
  outstanding: "ပွဲမပြီးသေးသော လောင်းကြေးများ",
  odds_type: "ပေါက်ကြေးအမျိုးအစား",
  odds: "ပေါက်ကြေး",
  opening_balance: "မူလငွေပမာဏ",
  outright: " ဖလားခန့်မှန်း",
  oe: "O/E",
  on: "ON",
  off: "OFF",
  outstanding_bet: "ပွဲမပြီးသေးသော လောင်းကြေးများ",
  over: "အပေါ်",
  odd: "မ",
  official_link: "Official Link",
  owner: "Owner",
  ou:"O/U",

  password_expiry: "စကားဝှက်သက်တမ်းကုန်ဆုံးသည်",
  parlay: "မောင်း",
  parlay_early: "Parlay Early",
  page_display: "စာမျက်နှာ ပုံစံ",
  page_type: "စာမျက်နှာ အမျိုးအစား",
  page_size: "စာမျက်နှာ အရွယ်အစား",
  personal_message: "ကိုယ်ရေးအကြောင်းအရာ",
  process_bet: "လောင်းငွေပမာဏ",
  payout: "လျော်ငွေ ပမာဏ",
  pending: "စောင့်ဆိုင်းနေသည်",
  personal: "Personal",
  play_now: "Play Now",
  parlay_generator: "Parlay Generator",
  private: "Private",
  pool: "Payout $",
  players: "Player",
  points: "Points",
  prize: "Prize",
  play_to_earn: "Play to Earn",

  quick_bet: "အမြန်လောင်းသည်",
  qq: "QQ",

  room: "Room",
  result: "ရလဒ်",
  restore: "မူလအခြေအနေသို့",
  remark: "မှတ်သားသည်",
  ref_no: "Ref No.",
  remove_from_parlay: "မောင်းကစားခြင်းမှ ဖယ်ရှားသည်",
  running: "လုပ်ဆောင်နေသည်",
  reject: "Rejected",
  rejected: "Rejected",
  rugby: "ရပ်ဘီ",
  roundof16: "Rounds of 16",
  quater_finals: "Quater Finals",
  semi_finals: "Semi Finals",
  room_id: "Room ID",
  refund: "Refund",

  skype: "Skype",
  sports: "အားကစားများ",
  show_balance: "လက်ကျန်ငွေ ပြသရန်",
  statement: "စာရင်း",
  settings: "ပြင်ဆင်ရန်",
  search_team: "အသင်းရှာသည်",
  show_header: "ခေါင်းစဥ်ပြသရန်",
  submit: "အတည်ပြုသည်",
  set_nickname: "Nickname ပြုလုပ်သည်",
  single: "တစ်မျိုးတည်း",
  save: "သိမ်းဆည်းသည်",
  show_score_map: "ပွဲစဥ်ခန့်မှန်းဇယားပုံ ပြသရန်",
  status: "အချက်အလက်",
  sort: "အပိုင်းအခြား",
  sportsbook: "အားကစား စုစည်းမှုများ",
  sum: "ပေါင်းခြင်း",
  special_announcements: "အထူးသတိပေးချက်များ",
  subtotal: "အသေးစားစာရင်းချုပ်",
  single_line: "တစ်ကြောင်းတည်း",
  sort_by_time: "အချိန်နှင့်ပိုင်းခြားထားသည်",
  slots: "Slots",
  select_leagues: "လိဒ်များရွေးချယ်သည်",
  special: "Special",
  scroll_bottom: "Tap to scroll to betting area",
  swipe_to_search: "Swipe To Search",
  soccer: "Soccer",
  squash: "Squash",
  sepak_takraw: "Sepak Takraw",
  snooker: "Snooker/Pool",
  suite_sa: "SA Gaming",
  suite_gp: "Game Play",
  suite_evo: "Evolution",
  suite_ct855: "CT855",
  suite_bg: "Macau Suite",
  suite_pg: "Pretty Gaming",
  suite_yb: "Yeebet",
  "suite_pp-c": "Pragmatic",
  suite_ai: "AI Casino",
  suite_sexy: "Sexy Casino",
  suite_onlive: "Onlive Casino",
  suite_mt: "MT Casino",
  suite_foxy: "Foxy Casino",
  sfv_101: "Round 1",
  sfv_102: "Round 2",
  sfv_103: "Round 3",
  sfv_104: "Round 4",
  sfv_105: "Round 5",
  settlement: "Settlement",
  settled_amount: "ငွေရှင်းပြီး",
  sfv: "Street Figther V",
  search: "Search",
  sysparlay: "System Parlay",
  stake_per_bet: "Stake Per Bet",
  score: "Score",
  winner: "Winner",
  slot_live22: "Live22",
  slot_pgs: "PGSoft",
  slot_ppg: "Pramagtic Play",
  slot_jkr: "Joker",
  slot_spp: "Simple Play",
  slot_jili: "Jili",
  slot_uusl: "UUSlot",
  slot_next: "Nextspin",
  slot_dbhash: "DB Hash",
  slot_wow: "WOW Gaming",
  slot_wf: "WF Gaming",
  slot_epw: "Epicwin",
  slot_epwmg: "Epicwin Mini",
  selected: "Selected",
  select_matches: "Select Matches",

  turnover: "အတည်ပြုသည့်ငွေပမာဏ",
  today: "ယနေ့ပွဲစဥ်",
  time: "အချိန်",
  team: "အသင်း",
  to: "သို့",
  trans_time: "အတည်ပြုချိန်",
  total: "စုစုပေါင်း",
  total_goal: "ဂိုးအရေအတွက်",
  treble: "Treble",
  total_bets: "Total Bets",
  tnc: "General Terms & Conditions",
  tennis: "တင္းနစ္	",
  table_tennis: "စားပြဲတင္ တင္းနစ္	",
  telegram: "Telegram",
  tournament: "Tournament",
  total_points: "Total Points",
  tournament_refund: "Tournament Refund",

  under: "အောက်",
  void: "ဖျက်သိမ်းသည်",
  volleyball: "ဘော်လီဘော",
  void_list: "Void List",
  view_odds: "View Odds",
  video: "Video",

  won_all: "Won All",
  won_half: "တဝက်နိုင်သည်",
  win_half: "Won Half",
  win: "နိုင်သည်",
  won: "နိုင်သည်",
  waiting: "စောင့်ဆိုင်းနေသည်",
  wechat: "Wechat",
  whatsapp: "Whatsapp",
  winter_sports: "Winter Sports",
  water_polo: "Water Polo",
  winner_rank: "Winner Rank",

  yes: "Yes",
  no: "No",

  yesterday: "မနေ့က",
  monday: "တနင်္လာ",
  tuesday: "အင်္ဂါ",
  wednesday: "ဗုဒ္ဓဟူး",
  thursday: "ကြာသပတေး",
  friday: "သောကြာ",
  saturday: "စနေ",
  sunday: "တနင်္ဂနွေ",

  all_league: "လိဒ်အားလုံး",
  match_completed: "ပွဲချိန်ပြီးဆုံး",
  match_pending: "ရလဒ်စောင့်ဆိုင်း",
  match_cancelled: "ပွဲပျက်",
  match_cancelled_1h: "ပထမပိုင်း ပွဲပျက်",
  match_cancelled_2h: "ဒုတိယပိုင်း ပွဲပျက်",
  match_suspended: "ပွဲပျက်",
  match_suspended_1h: "ပထမပိုင်း ပွဲပျက်",
  match_suspended_2h: "ဒုတိယပိုင်း ပွဲပျက်",

  check_all: "အားလုံးမှတ်ယူသည်",
  selected_only: "မှတ်သားထားသည့် အရာများသာ",
  filtered: "စီစစ်ထားသည်",
  turn_on: "ON",
  turn_off: "OFF",

  more_bet_types: "More Bet Types",
  switch_to_desktop: "Switch to Desktop",

  events: "Events",
  brackets: "Brackets",
  standing: "Standing",

  big_small: "Big/Small",
  odd_even: "Odd/Even",

  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total of Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  total_winlose: "Total Win/Lose",
  tomorrow: "Tomorrow",

  news: "News",
  more: "More",
  current_live: "Current Live",
  upcoming: "Upcoming",
  prematch: "Prematch",
  desktop_view: "Desktop View",
  back_to_lobby: "Back to Lobby",
  coming_soon: "Coming Soon",
  no_record: "No record found",
  bet_time: "Bet Time",
  seven_days: "Last 7 Days",
  fourteen_days: "Last 14 Days",
  winlose: "Win/Lose",
  all_transaction: "All Transaction",
  transfer: "Transfer",
  hide: "Hide",
  more_details: "More details",
  bet: "Bet",
  comm: "Comm",
  settled: "Settled",
  total_stake: "Total Stake",
  deselect_all: "Deselect All",
  select_all: "Select All",
  done: "Done",
  early_all: "Early (All)",
  more_markets: "More Markets",
  folds_2: "2 Folds",
  folds_3: "3 Folds",
  folds_4: "4 Folds",
  folds_5: "5 Folds",
  folds_6: "6 Folds",
  folds_7: "7 Folds",
  folds_8: "8 Folds",
  folds_9: "9 Folds",
  folds_10: "10 Folds",
  folds_11: "11 Folds",
  folds_12: "12 Folds",
  go_today_matches: "Go Today Matches",
  go_live_matches: "Go Live Matches",
  remember_stake: "Remember Stake",
  confirm: "Confirm",
  parlay_slip: "Parlay Slip",
  parlay_slip_selection: "Parlay Slip - Selection",
  remove_all: "Remove All",
  add_more_selection: "Add More Selection",
  retain_selections: "Retain Selections",
  settled_remark: "Note: Bets from today market are displayed, settled match's tickets will be moved to statement.",
  w4d: "4D",
  tutorial_tooltips: "How to install this app on home screen",
  tutorial: "Tutorial",
  dismiss: "Dismiss",
  euroDate: "12 JUNE - 12 JULY",
  goto_statement: "Go to Statement",
  no_bet: "No Bet",

  random_pick: "Generate",
  add_pick: "Add To Bet Slip",

  worldcup: "WORLD CUP 2022",
  time_remaining: "Time Remaining",

  slot_championstar: "Champion Star",
  slot_fifafiesta: "Fifa Fiesta",
  slot_penaltymania: "Penalty Mania",
  minigame_dragon: "Dragon's Treasure",
  minigame_illuvium: "Illuvium Master",
  minigame_mobo: "Mobox Olympia",

  egames: "V-Games",
  feedback: "User Experience Feedback",
  ranking: "Ranking",
  total_winning: "Total Winning",
  first_prize: "1st Prize",
  second_prize: "2nd Prize",
  third_prize: "3rd Prize",
  place: "Place",
  current_point: "Current Point",
  free_room: "Free Room",
  last_join_time: "Last Join Time",
  archery: "စားရှင်းပွဲ",
  winter_olympic: "သွေးဆောင်ရိုလာနိုင်ငံအော်လှန်ကျွန်း",
  no1: "ပထမနေရာဆုရရှိသူ",
  adjustment: "ညှိနှိုင်းမှု",
  poker: "ပိုကာ",
  poker_db: "DB Poker",
  yellow: "အဝါရောင်",
  blue: "အပြာ",
  first_ball: "ပထမဘော",
  best_5_balls: "အကောင်းဆုံးဘော ၅ လုံး",
  binary_allin: "Binary",
  round1: "ပထမနေရာဆုရရှိသူ",
  round2: "ဒုတိယနေရာဆုရရှိသူ",
  round3: "တတိယနေရာဆုရရှိသူ",   
  
  round1_1stBoom: "ပထမအချီ ပထမ BOOM",
  round2_1stBoom: "ဒုတိယအချီ ပထမ BOOM",
  round3_1stBoom: "တတိယအချီ ပထမ BOOM",

  modern_view: "မြန်မာနှင့်ဆက်သွယ်မှု",
  switching_to_modern_view: "မြန်မာနှင့်ဆက်သွယ်မှုသို့ပြောင်းလဲခြင်း...",
  cashout: "ငွေပြန်ခရင်",
  available: "အသုံးပြုနိုင်",
  
  time_machine_tm: "(အချိန်စက်)",
  beta_tag: "ဘီတာ",
};
